import type { AfterResponseHook } from 'ky';
import { LOGOUT_URL } from '../../../../auth/const';
import { clearDpopKeyPair } from '../../../../dpop/store';

// logout has many entry points; this is the one place they all pass through
export const clearDpopKeyOnLogout: AfterResponseHook = (request, _options, response) => {
  // a logout that never reached the server leaves a session that still needs the key
  if (!response.ok) return;
  const url = new URL(request.url);
  if (!url.pathname.endsWith(LOGOUT_URL)) return;

  // returned so ky awaits it — logout hard-navigates right after. Scoped to this backend, so
  // signing out of the host app leaves a live embed's key alone.
  return clearDpopKeyPair(url.origin);
};
